// extracted by mini-css-extract-plugin
export default {"Footer":"NavigationItem_Footer__f0uvp","Header":"NavigationItem_Header__5xFpQ"};